// Available entity types for the endpoint /human/{entity_type}/{entity_id}/set_properties
export enum EntityTypeEnum {
  PLANT = "plant",
  TRACKER = "tracker",
  IMMERSION_HEATER = "immersionHeater",
  ESS = "ess",
}
